import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode } from "vue"

import AList from '@/components/atoms/AList.vue'

	import type { ComputedRef } from 'vue'
	import { reactive, computed } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		icon: { type: String, default: '' },
		text: { type: String, default: '', required: true },
		defaultValue: { type: String, default: '', required: true },
		items: { type: Array, default: () => [], required: true },
		minWidth: { type: [String, Number], default: undefined }
	},
  emits: ['click'],
  setup(__props, { emit: $emit }) {

const $props = __props

	const { $t, icons } = useGeneral()

	
	

	const state = reactive({
		menu: false
	})

	const menuEnabled: ComputedRef<boolean> = computed(() => $props.items.length > 1)
	const menuIcon: ComputedRef<string> = computed(() => (state.menu ? icons['chevronUp'] : icons['chevronDown']))

	const splitMinWidth = 35
	const actionMinWidth: ComputedRef<number | undefined> = computed(() =>
		$props.minWidth !== undefined ? (menuEnabled.value ? Number($props.minWidth) - splitMinWidth : Number($props.minWidth)) : undefined
	)

	function actionClick() {
		$emit('click', $props.defaultValue)
	}
	function dropdownClick(val: any) {
		$emit('click', val)
	}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: _unref(state).menu,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).menu) = $event)),
    anchor: "bottom",
    disabled: !_unref(menuEnabled)
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
        _createVNode(_component_v_btn, {
          variant: "contained",
          color: "success",
          class: _normalizeClass({ 'btn-split-action': _unref(menuEnabled) }),
          "min-width": _unref(actionMinWidth),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (actionClick()), ["stop"]))
        }, {
          default: _withCtx(() => [
            ($props.icon)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  icon: $props.icon
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref($t)($props.text)), 1)
          ]),
          _: 1
        }, 8, ["class", "min-width"]),
        (_unref(menuEnabled))
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              "min-width": splitMinWidth,
              variant: "contained",
              color: "success",
              class: "btn-split-dropdown"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: _unref(menuIcon) }, null, 8, ["icon"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 16)
    ]),
    default: _withCtx(() => [
      _createVNode(AList, {
        items: __props.items,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (dropdownClick($event))),
        style: {"top":"12px"}
      }, null, 8, ["items"])
    ]),
    _: 1
  }, 8, ["modelValue", "disabled"]))
}
}

})